import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { useAccountCreationContext } from "@/components/signup/account-creation";
import { Button } from "@/libraries/design/components";

export const InlineSubmit = ({ isValid }: { isValid?: boolean }) => {
    const intl = useIntl();
    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    const buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });

    return (
        <Button
            css={[buttonCss, isValid === false && invalidCss]}
            type="submit"
            disabled={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
            data-testid="embedded-signup-submit"
        >
            {buttonText}
        </Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    height: "auto",
    margin: "-1px -1px -1px 0",
    padding: "12px 24px !important",
    whiteSpace: "nowrap",
    [media.below.sm]: {
        width: "100%",
        maxWidth: "100%"
    }
});

const invalidCss = css({
    margin: "-2px -2px -2px 0"
});
